import {useEffect, useRef, useState} from "react";
import {EventEmitter} from "../../../app/eventEmitter/EventEmitter";
import {EventsModal} from "../../../app/eventEmitter/Events";

/**
 * Hook для инициализации начальных позиций модалки относительно поля поиска.
 * Также реализует состояние открытия и закрытия окна.
 *
 * @returns {{
 *   isOpen: boolean,
 *   inputRef: React.RefObject<HTMLInputElement>,
 *   modalPosition: ModalPosition,
 *   openModal: () => void,
 *   closeModal: () => void
 * }}
 */
export const useSearchWidgetStartPosition = () => {
    const inputRef = useRef<HTMLInputElement>(null);
    const [isOpen, setIsOpen] = useState(false);
    const [modalPosition, setModalPosition] = useState({
        top: 0,
        left: 0,
        // width: 0,
        height: 300,
    });

    const calculatePosition = () => {
        if (inputRef.current) {
            const rect = inputRef.current.getBoundingClientRect();
            const windowHeight = window.innerHeight;

            const top = rect.bottom + 10; // fixed -> напрямую без scrollY
            const left = rect.left;
            const height = windowHeight - rect.bottom - 40; // 20px до низа окна
            setModalPosition({
                top,
                left,
                height,
            });
        }
    };

    const openModal = () => {
        calculatePosition();
        setIsOpen(true);
        const evenName = EventsModal.modalShow;
        EventEmitter.emit(evenName, {});

    };
    const closeModal = () => {
        setIsOpen(false);
        const evenName = EventsModal.modalHide;
        EventEmitter.emit(evenName, {});
    }

    useEffect(() => {
        const handleResizeOrScroll = () => {
            if (isOpen) {
                calculatePosition();
            }
        };
        window.addEventListener('resize', handleResizeOrScroll);
        window.addEventListener('scroll', handleResizeOrScroll);
        return () => {
            window.removeEventListener('resize', handleResizeOrScroll);
            window.removeEventListener('scroll', handleResizeOrScroll);
        };
    }, [isOpen]);

    return {
        isOpen,
        inputRef,
        modalPosition,
        openModal: openModal,
        closeModal: closeModal
    }


}